import React from 'react';
import { Loader2 } from 'lucide-react';
import type { LscVodCandidate } from '../types';
import { vodListVerificationLabel, vodListVerificationStyle } from '../vodTruth';
import { truthVerificationInProgress } from '../vodTruthVerificationPolling';

interface VerificationStatusBadgeProps {
  candidate: LscVodCandidate;
}

const VerificationStatusBadge: React.FC<VerificationStatusBadgeProps> = ({ candidate }) => {
  const inProgress = truthVerificationInProgress(candidate);
  const { label, tone, metadataHint } = vodListVerificationLabel(candidate);

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${vodListVerificationStyle(tone)}`}
      title={metadataHint ?? undefined}
      data-testid="verification-status-badge"
    >
      {inProgress ? (
        <Loader2 className="mr-1 h-3 w-3 shrink-0 animate-spin" aria-hidden="true" />
      ) : null}
      {label}
    </span>
  );
};

export default VerificationStatusBadge;
